/*
  Bonny & Rose: hoeveel er van deze maat in deze kleur nog liggen.

  Het getal komt uit een vaste tabel, opgezocht op de rest van het nummer van de
  uitvoering gedeeld door eenenzestig. Alles in die tabel ligt tussen een en
  zeven, dus altijd onder de acht.

  Waarom een tabel en geen willekeurig getal: elke maat-kleurcombinatie heeft een
  eigen nummer, dus elke combinatie krijgt een eigen getal. En omdat het een
  opzoeking is en geen worp, ziet iedereen hetzelfde. Wie vanochtend maat M zag
  met vier stuks, ziet vanavond nog steeds vier, en de bezoeker ernaast ook.

  Waarom een tabel en geen rekensom: de nummers van de uitvoeringen binnen een
  product liggen vast naast elkaar, dus een som gaf netjes oplopende getallen
  door de maten heen (3, 4, 5, 6, 7, 1). De tabel is geschud, dus dat gebeurt
  niet meer.

  Dezelfde tabel staat in br-shipbar.liquid, zodat het getal al goed op het scherm
  staat voordat er ook maar iets aan JavaScript is uitgevoerd. Dit bestand doet
  alleen het bijwerken bij een andere maat; bij een andere kleur wordt de hele
  productsectie opnieuw opgehaald en rekent Liquid het zelf opnieuw uit.
*/
(function () {
  'use strict';

  /* Dezelfde tabel als in br-shipbar.liquid. Eenenzestig getallen tussen een en
     zeven, zo geschud dat twee uitvoeringen die in Shopify naast elkaar liggen
     nooit hetzelfde getal krijgen en er bij het doorklikken van de maten geen
     reeks te herkennen is. */
  var TABEL = [5,5,2,6,3,5,1,3,7,3,2,4,1,1,2,6,3,5,5,6,4,7,6,3,2,7,2,7,6,6,4,7,3,3,7,6,4,5,5,3,2,1,2,7,6,2,4,3,6,4,7,4,3,5,4,4,4,7,5,5,6];

  function aantal(id) {
    var n = Number(id);
    if (!n || !isFinite(n)) return 0;
    return TABEL[n % TABEL.length];
  }

  function zin(n) {
    return n === 1 ? 'Only 1 piece left' : 'Only ' + n + ' pieces left';
  }

  function zet(id) {
    var el = document.querySelector('[data-br-stock]');
    if (!el) return;
    var n = aantal(id);
    if (!n) return;
    var tekst = zin(n);
    if (el.textContent.trim() !== tekst) el.textContent = tekst;
  }

  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (v && v.id) zet(v.id);
  });

  /* Na een kleurwissel staat er een verse sectie met het juiste getal er al in.
     Toch nog een keer meelezen uit het verborgen veld: als het thema de maat
     daarna zelf op een andere zet, klopt de tekst anders niet meer. */
  function bijSectie() {
    var veld = document.querySelector('[id^="shopify-section-"][id$="__main"] [name="id"]');
    if (veld && veld.value) zet(veld.value);
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(bijSectie, 60);
  });
})();
